export default "__VITE_ASSET__BouvXmFM__"